/**
 * Advanced utility to programmatically trigger the Callbird chat widget
 */
export const triggerChat = () => {
  // 1. Array of potential selectors for the chat launcher
  const selectors = [
    '.callbird-launcher',
    '#callbird-chat-icon',
    '[data-testid="launcher"]',
    '.callbird-widget-button',
    '#callbird-widget-launcher',
    'div[class*="launcher"]',
    'button[class*="launcher"]'
  ];

  let launcher = null;

  // 2. Search for the launcher in the main document
  for (const selector of selectors) {
    launcher = document.querySelector(selector);
    if (launcher) break;
  }

  // 3. If not found, check inside iframes (common for chat widgets)
  if (!launcher) {
    const iframes = document.querySelectorAll('iframe');
    for (const iframe of iframes) {
      try {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        for (const selector of selectors) {
          launcher = iframeDoc.querySelector(selector);
          if (launcher) break;
        }
      } catch (e) {
        // Cross-origin iframe, cannot access content
        continue;
      }
      if (launcher) break;
    }
  }

  // 4. Perform the click action
  if (launcher) {
    // Basic click
    launcher.click();
    
    // Advanced event dispatching for complex widgets
    const events = ['mousedown', 'click', 'mouseup'];
    events.forEach(eventType => {
      const event = new MouseEvent(eventType, {
        view: window,
        bubbles: true,
        cancelable: true,
        buttons: 1
      });
      launcher.dispatchEvent(event);
    });
  } else {
    // 5. Fallback: If launcher still not found (script loading), scroll to bottom
    // and try to find any fixed element in the bottom-right corner
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    console.warn('Chat launcher not found. Ensure the widget script is fully loaded.');
  }

  // 6. Pulse the "Talk to us live" guide
  window.dispatchEvent(new CustomEvent('trigger-chat-highlight'));
};